import React, { useEffect } from 'react';
import { FaCogs, FaLaptopCode, FaAndroid, FaApple, FaCloud, FaPaintBrush, FaBullhorn } from 'react-icons/fa';
import { MdDevices } from 'react-icons/md';
import { BiCodeCurly } from 'react-icons/bi';
import AOS from "aos";
import "aos/dist/aos.css";
import TechServiceCard from '../Components/TechServiceCard';
import services from '../data/LandingSectionData/techSolutions';



const TechSolutions = () => {

  useEffect(() => {
        AOS.init();
      }, []);

  return (
    <section className="bg-bgDefault text-white px-4 py-12 lg:py-28 lg:px-28">
       <div className="container xl:mx-auto xl:max-w-screen-xl  overflow-hidden">
      <div className="lg:text-center text-left mb-12 ">
        <h2 className="font-dmsans font-bold text-[35px] leading-[41px] tracking-[-6%] lg:text-heading-2 ">
          Smart, <span className="text-[#00E599] text-[35px] leading-[39px] font-crimsonpro italic font-normal lg:text-heading-2">Scalable</span>{' '}
          <span>Tech Solutions</span>{' '}
          <br></br>
          <span>Designed to Fuel Your Next Big Idea</span>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 " 
      // data-aos="fade-right"
      >
      {services.map((service, index) => (
            <TechServiceCard
              key={index}
              image={service.image}
              name={service.name}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechSolutions;
